export default import.meta.ROLLUP_FILE_URL_0rLQBODBFA$kncq5FV$ZNw